type ApiSessionCheck = () => Promise<void>;

let checkApiSession: ApiSessionCheck | undefined;
let pendingApiSessionCheck: Promise<void> | undefined;

export const registerApiSessionCheck = (check: ApiSessionCheck | undefined) => {
  checkApiSession = check;
};

export const waitForFreshApiSession = () => {
  if (!checkApiSession) return;
  if (pendingApiSessionCheck) return pendingApiSessionCheck;

  // Collapse each tab's request fan-out before auth-js coordinates across tabs.
  const pendingCheck = checkApiSession()
    .catch((error: unknown) => {
      console.warn(
        "Browser session check failed; continuing API request",
        error
      );
    })
    .finally(() => {
      if (pendingApiSessionCheck === pendingCheck) {
        pendingApiSessionCheck = undefined;
      }
    });
  pendingApiSessionCheck = pendingCheck;
  return pendingCheck;
};
